<template>
  <v-container
    v-if="access.includes(roles.dashboard)"
    id="dashboard"
    fluid
    tag="section"
  >
    <v-row>
      <v-col
        cols="12"
        sm="6"
        lg="3"
      >
        <base-material-stats-card
          color="teal"
          icon="mdi-account-tie"
          title="Managers"
          :value="manager_count.toString()"
          sub-icon=""
          sub-text=""
        />
      </v-col>

      <v-col
        cols="12"
        sm="6"
        lg="3"
      >
        <base-material-stats-card
          color="info"
          icon="mdi-account-box-multiple"
          title="Crew"
          :value="crew_count.toString()"
          sub-icon=""
          sub-text=""
        />
      </v-col>

      <v-col
        cols="12"
        sm="6"
        lg="3"
      >
        <base-material-stats-card
          color="purple"
          icon="mdi-account-lock-outline"
          title="Users"
          :value="user_count.toString()"
          sub-icon=""
          sub-text=""
        />
      </v-col>

      <v-col
        cols="12"
        sm="6"
        lg="3"
      >
        <base-material-stats-card
          color="pink"
          icon="mdi-calendar-multiple-check"
          title="Projections"
          :value="projection_count.toString()"
          sub-icon=""
          sub-icon-color=""
          sub-text=""
        />
      </v-col>

      <v-col
        cols="12"
        md="6"
      >
        <base-material-card
          color="primary"
          class="px-5 py-3"
        >
          <template v-slot:heading>
            <div class="text-h3 font-weight-light">
              Crew Stats
            </div>

            <div class="text-subtitle-1 font-weight-light">
              New crew on {{ GetCurrentMonth() }}
            </div>
          </template>
          <v-card-text>
            <v-data-table
              :headers="latest_crew_headers"
              :items="latest_crew"
              :options.sync="options"
              :loading="loading"
            />
          </v-card-text>
        </base-material-card>
      </v-col>

      <v-col
        cols="12"
        md="6"
      >
        <base-material-card
          class="px-5 py-3"
          color="warning"
        >
          <template v-slot:heading>
            <div class="text-h3 font-weight-light">
              Data Projection
            </div>

            <div class="text-subtitle-1 font-weight-light">
              History
            </div>
          </template>
          <v-card-text>
            <v-data-table
              :headers="projections_headers"
              :items="projections"
              :options.sync="options2"
              :loading="loading"
            />
          </v-card-text>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import moment from 'moment'
  import {
    GetStoreTotals,
  } from '@/graphql/Dashboard.gql'
  // Utilities
  // rebuild
  import {
    mapState,
  } from 'vuex'
  export default {
    name: 'DashboardDashboard',
    data () {
      return {
        manager_count: 0,
        crew_count: 0,
        user_count: 0,
        projection_count: 0,
        latest_crew: [],
        projections: [],
        loading: false,
        skip: false,
        options: {
          page: 1,
          itemsPerPage: 5,
        },
        options2: {
          page: 1,
          itemsPerPage: 5,
        },
        latest_crew_headers: [
          {
            sortable: false,
            text: 'Name',
            value: 'name',
          },
          {
            sortable: false,
            text: 'Position',
            value: 'position',
          },
          {
            sortable: false,
            text: 'Status',
            value: 'status',
          },
          {
            sortable: false,
            text: 'Date Hired',
            value: 'date_hired',
            align: 'right',
          },
        ],
        projections_headers: [
          {
            sortable: false,
            text: 'Projection Date',
            value: 'date',
          },
          {
            sortable: false,
            text: 'Created By',
            value: 'created_by',
          },
        ],
      }
    },
    computed: {
      ...mapState(['access', 'roles']),
    },
    mounted () {
      window.scrollTo(0, 0)
    },
    methods: {
      GetCurrentMonth () {
        return moment().format('MMM YYYY')
      },
      GetStoreTotals () {
        this.loading = true
        this.latest_crew = []
        this.projections = []
        this.skip = false
        this.$apollo.queries.GetStoreTotals.refetch()
      },
    },
    apollo: {
      GetStoreTotals: {
        error (error) {
          this.loading = false
          this.CheckError(error)
        },
        query: GetStoreTotals,
        variables () {
          return {
          }
        },
        skip () {
          return this.skip
        },
        result ({ data, loading }) {
          if (!loading) {
            if (data && data.GetStoreTotals.status === 'Ok') {
              this.manager_count = data.GetStoreTotals.manager_count
              this.crew_count = data.GetStoreTotals.crew_count
              this.user_count = data.GetStoreTotals.user_count
              this.projection_count = data.GetStoreTotals.projection_count
              this.latest_crew = data.GetStoreTotals.latest_crew
              this.projections = data.GetStoreTotals.projections
            } else if (data.GetStoreTotals.status === '0') {
              this.CheckError({ message: 'Session expired!' })
            }
            this.loading = false
            this.skip = true
          }
        },
      },
    },
  }
</script>
